module.exports = __webpack_public_path__ + "static/img/more.c0f739d4.png";